import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as accounting from 'accounting';
import * as moment from 'moment';
import BumpSetup from './bump_setup';
import BumpChange from './bump_change';
import BumpBidSlider from './bump_bid_slider';

class ProductPageBump extends React.Component {
  get bidSlider() {
    return (
      <BumpBidSlider
        bidTiers={this.props.bidTiers}
        tierIncrement={this.props.tierIncrement}
        bid={this.props.selectedBid}
        setBid={this.props.bid}
        updateBid={this.props.updateBid}
        onBidChange={this.props.onBidChange}
        error={this.props.error}
        didBidChange={this.props.didBidChange}
        changeDismiss={this.props.changeDismiss}
        deleted={this.props.deleted}
      />
    );
  }

  get showStats() {
    return this.props.bid ||
      this.props.salesCount ||
      accounting.unformat(this.props.salesSpent) ||
      accounting.unformat(this.props.salesRevenue);
  }

  get content() {
    if (this.showStats) {
      return (
        <BumpChange
          bidSlider={this.bidSlider}
          impressions={this.props.impressions || 0}
          salesCount={this.props.salesCount || 0}
          salesSpent={this.props.salesSpent || '0'}
          salesRevenue={this.props.salesRevenue || '0'}
          averagePosition={this.props.averagePosition || 0}
          hasComparisonShoppingPage={this.props.hasComparisonShoppingPage}
          showMobileSlider={this.props.showMobileSlider}
          sliderToggle={this.props.sliderToggle}
          currentBid={this.props.selectedBid}
          hasInventory={this.props.hasInventory}
        />
      );
    }

    return (
      <BumpSetup
        bidSlider={this.bidSlider}
        exampleBumpPercent={this.props.exampleBumpPercent}
        listingPrice={this.props.listingPrice}
        shippingPrice={this.props.shippingPrice}
        exampleSpend={this.props.exampleSpend}
        isNewCondition={this.props.isNewCondition}
        showMobileSlider={this.props.showMobileSlider}
        sliderToggle={this.props.sliderToggle}
      />
    );
  }

  get adminBidMessage() {
    const { adminBid } = this.props;
    if (!(adminBid && adminBid.bid)) { return null; }

    return (
      <h1 className="product-bump__admin-bump-header">
        {I18n.t('js.bump.adminBump', {
          percentage: adminBid.bid * 100,
          expirationDate: moment(adminBid.expiresAt).format('MMMM D'),
        })}
      </h1>
    );
  }

  render() {
    return (
      <div>
        {this.adminBidMessage}
        {this.content}
      </div>
    );
  }
}

ProductPageBump.propTypes = {
  productId: PropTypes.number.isRequired,
  bidTiers: PropTypes.array.isRequired,
  tierIncrement: PropTypes.number.isRequired,
  bid: PropTypes.number,
  adminBid: PropTypes.object,
  impressions: PropTypes.number,
  salesCount: PropTypes.number,
  salesSpent: PropTypes.string,
  salesRevenue: PropTypes.string,
  averagePosition: PropTypes.number,
  exampleBumpPercent: PropTypes.string,
  listingPrice: PropTypes.string,
  shippingPrice: PropTypes.string,
  exampleSpend: PropTypes.string,
  hasComparisonShoppingPage: PropTypes.bool,
  hasInventory: PropTypes.bool,
  error: PropTypes.bool.isRequired,
  didBidChange: PropTypes.bool.isRequired,
  onBidChange: PropTypes.func.isRequired,
  isNewCondition: PropTypes.bool.isRequired,
};

export default ProductPageBump;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/bump_for_new/product_page_bump.jsx